import DefaultLayout from '##/Default';
import List from './List';

const routes = [

    {
        path: '/lawyers',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Manage Lawyers'
    }
];


export default routes;
